export const HitEffect = {
  None: 'none',
  Slide: 'slide',
  Impact: 'impact'
} as const;
export type HitEffectKeys = keyof typeof HitEffect;
export type HitEffectValues = typeof HitEffect[HitEffectKeys];

export default class LaneEntityImageBase extends Phaser.Physics.Matter.Image {
  public scene: Phaser.Scene;

  // protected onHitCallback: ((self: LaneEntityImageBase) => void) | undefined;
  protected hasBeenHit: boolean;

  constructor(scene: Phaser.Scene, x: number, y: number, texture: string, frame?: number | string) {
    super(scene.matter.world, x, y, texture, frame, {
      isSensor: true,
      isStatic: true
    });

    this.scene = scene;
    this.hasBeenHit = false;
  }

  get HasBeenHit() {
    return this.hasBeenHit;
  }

  // public init(onHitCallback?: (self: LaneEntityImageBase) => void) {
  //   this.onHitCallback = onHitCallback;
  // }

  public init() {}

  public reset() {
    this.alpha = 1;
    // this.setScale(1);
    this.setVisible(true);
    this.setActive(true);

    this.hasBeenHit = false;
  }

  public recycle() {
    this.scene.tweens.killTweensOf(this);
    this.setVisible(false);
    this.setActive(false);
    this.setPosition(-1000, 0);
  }

  public onHit(wasPlayer: boolean, isSingleUse: boolean, hitPointX: number, delay: number) {
    if (isSingleUse) {
      this.scene.add.tween({
        targets: this,
        alpha: 0,
        duration: 250,
        ease: Phaser.Math.Easing.Circular.InOut,
        delay: delay,
        onComplete: () => {
          this.hasBeenHit = true;
        },
        onCompleteScope: this
      });
    }
  }
}
